<template>
    <div class="hd_pri row">
        <div v-if="this.election">
            <div class="election-title">{{this.election.title1}} {{ this.election.title2 }} - {{formatDate(this.election.electionDate)}}</div>
        </div>
        <div v-else class="election-title">Loading...</div>
    </div>
    <div id="form-election" class="form m-rows row">
        <div id="contestDropdown" :class="['form-part layout m-span']">
            <div class="label">
                <span>{{ $t("LabelContest") }}</span>
            </div>
            <div class="dropdown input">
                <select id="contest-select" class="span" v-model="contestSelected" @change="onContestChangeHandler">
                    <option 
                        v-for="contest in getContestList" 
                        v-bind:value="contest.contestId" 
                        v-bind:key="contest.contestId"
                        :selected="contest.contestId === contestSelected">{{`${contest.title} ${contest.title2}`}}</option>
                </select> 
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { FETCH_CANDIDATELIST, FETCH_CONTESTLIST, FETCH_ELECTIONLIST, SET_SEARCH } from '../store/actions.type';
import { ASSETS } from '@/assets/js/assets.js';
import appConfiguration from '../../package.json';
export default {
    computed: {
        ...mapGetters(["yearList", "electionList", "contestList", "contest", "election", "year"]),
        getElectionList() {
            return this.electionList ? this.electionList : [];
        },
        getContestList() {
            return this.contestList ? this.contestList : [];
        },
        getYearList() {
            return this.yearList ? this.yearList : [];
        },
    },
    data() {
        return {
            yearSelected: undefined,
            electionSelected: undefined,
            contestSelected: undefined,
            ASSETS
        }
    },
    methods: {
        formatDate(date) {
            const newDate = new Date(date);
            const formattedDate = newDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
            });
            return formattedDate
        },
        async onContestChangeHandler() {
            await this.$store.dispatch(SET_SEARCH, null);
            const sel = document.getElementById("contest-select");
            const text = sel.options[sel.selectedIndex].text;
            document.getElementById(`${text} `).scrollIntoView(); // Empty space after text required
        },
    },
    async beforeMount() {
        if (this.election === undefined || this.contest === undefined || 
            (this.$store.state.appVersion === undefined || this.$store.state.appVersion !== appConfiguration.version)) {
            if (this.$store.state.appVersion === undefined || this.$store.state.appVersion !== appConfiguration.version) {
                this.$store.state.appVersion = appConfiguration.version;
            }
            await this.$store.dispatch(FETCH_ELECTIONLIST, this.yearList[0]);
            await this.$store.dispatch(FETCH_CONTESTLIST, this.electionList[0].electionId);
            await this.$store.dispatch(FETCH_CANDIDATELIST, this.contestList[0].contestId);
        }
        if (this.election && this.contest) {
            await this.$store.dispatch(FETCH_CONTESTLIST, this.election.electionId);
        }
        this.electionSelected = this.election ? this.election.electionId : 0;
        this.contestSelected = this.contest ? this.contest.contestId : 0;
    }
}
</script>

<style>
.navi select {
    width: 100%;
}
</style>